import { COUNTRIES } from '../constants/countries';

export const doesCountrySupportValidation = (countryCode: string) => {
  const country = COUNTRIES.find(
    (country) => country.abbreviation.toLowerCase() === countryCode.toLowerCase()
  );

  return country && country.supportsAddressValidation;
};
